;(function($, undefined){

    var rnn, log, isThirdParty;

    function showSubscriptionsFormModal() {
        $(
            $.el.div({'class': 'modal hide fade mailchimp-subscriptions-form-modal'},
                $.el.div({'class': 'modal-header'},
                    $.el.button({'class': 'close', 'data-dismiss': 'modal'},
                        '\u00D7'
                    ),
                    $.el.div({'class': 'clearfix'},
                        $.el.div({'class': 'sectionBanner auto pull-left'},
                            $.el.h2('Sign Up!')
                        ),
                        $.el.h2({'class': 'text-success upper margin-left pull-left'},
                            'Daily Newsletters'
                        )
                    )
                ),
                $.el.div({'class': 'modal-body'})
            )
        )
        .appendTo('body')
        .modal({remote: '/mailchimp/subscriptions-form/'});
    }

    function initSubscriptionsFormModal() {
        var cookieName = 'mailchimp.subscriptionsFormModalSeen';
        var cookieOptions = { expires: 365, path: '/' };

        if (!Cookies.get(cookieName)) {
            Cookies.set(cookieName, 'yes', cookieOptions);
            showSubscriptionsFormModal();
        }
    }

    function initMailchimp() {
        // Restict modal to AU sites with the modal enabled, which aren't header/footer includes
        if (Modernizr.cookies && rnn.site.network.isAU && rnn.site.showSubscriptionModal && !isThirdParty) {
            initSubscriptionsFormModal();
        }
    }

    rnn = window.rnn;
    log = rnn.logging.log;
    isThirdParty = !!window.header_only || !!window.footer_only;

    rnn.modules.register('mailchimp', {
        init: initMailchimp
    });

})(jQuery);
